import React from 'react';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { useSuperFlowClient } from '@/shared/libs/logger/useSuperFlowClient';

function getCleanUrl() {
  const url = new URL(location.href);
  const cleanUrl = url.origin + url.pathname;

  return cleanUrl;
}

export function useGuideFeedback() {
  const [status, setStatus] = React.useState<'INIT' | 'READY' | 'SEND'>('INIT');

  const { isReadyToSend, trackCxHelpFeedbackLog } =
    useSuperFlowClient(appPublicConfig);

  const send = React.useCallback(
    (helpful: boolean) => {
      // Log送信は待たない
      setStatus('SEND');

      trackCxHelpFeedbackLog({
        url: getCleanUrl(),
        action: 'feedback',
        helpful,
      });
    },
    [trackCxHelpFeedbackLog]
  );

  React.useEffect(() => {
    if (!isReadyToSend) return;

    setStatus('READY');

    trackCxHelpFeedbackLog({
      url: getCleanUrl(),
      action: 'view',
    });
  }, [isReadyToSend, trackCxHelpFeedbackLog]);

  return {
    status,
    send,
  };
}
